import { proxy, ref } from 'valtio';

import { SubscriptionFromSubscriptionType, SubscriptionType } from 'models';

import type { SubscriptionUpdateCommonPropsWithoutDefaults } from 'components/subscriptions/types';
import { ModalService } from 'services/ModalService';
import { state as currentUserState } from 'state/current-user';

export type SubscriptionModalOptions<T extends SubscriptionType = SubscriptionType> = {
    type: T;
    toSubscription: SubscriptionFromSubscriptionType<T>;
} & SubscriptionUpdateCommonPropsWithoutDefaults;

const SubscriptionModalService = {
    state: proxy({
        options: null as SubscriptionModalOptions | null,
    }),

    open: <T extends SubscriptionType>(options: SubscriptionModalOptions<T>) => {
        if (!currentUserState.user) {
            ModalService.openLoginModal({
                title: 'Ready to upgrade?',
                message: 'Create account or login to continue',
            });

            return;
        }

        SubscriptionModalService.state.options = ref(options);
    },

    close: () => {
        SubscriptionModalService.state.options = null;
    },
};

export { SubscriptionModalService };
